import { FC } from 'react';
import { Box, Button, Container, Grow, Stack, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlassChart } from '@fortawesome/free-solid-svg-icons';
import { useMobile } from '../../contexts/mobile.context.tsx';
import { trackEvent } from '../../utils/analytics.ts';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../constants/paths.ts';

export const TrackingPage: FC = () => {
  const { sendMessage } = useMobile();
  const navigate = useNavigate();
  return (
    <Grow in>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          pb: 10
        }}
      >
        <Container
          sx={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Stack gap={3}>
            <Typography variant="h3" paragraph>
              App Analytics
            </Typography>
            <Box>
              <FontAwesomeIcon icon={faMagnifyingGlassChart} size="6x" color="#45b6fe" />
            </Box>
            <Typography sx={{ color: 'text.secondary' }}>
              The ABLE App uses analytics to help us understand how you use the app and how we can improve it. We do not collect any personal information.
            </Typography>
            <Box display="flex" justifyContent="center">
              <Stack gap={3} width="100%" maxWidth="sm">
                <Button
                  size="large"
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    trackEvent('tracking_enable_request');
                    if (/Android/i.test(navigator.userAgent)) {
                      navigate(Paths.HOME);
                    } else {
                      sendMessage('TRACKING', 'RequestTracking');
                    }
                  }}
                >
                  Enable Tracking
                </Button>
              </Stack>
            </Box>
          </Stack>
        </Container>
      </Box>
    </Grow>
  );
};
